module.exports = __webpack_public_path__ + "img/smart_info.f14c30ac.png";